import { GeneralRoutes } from './general.routes';
import { MyAccountRoutes } from './my-account.routes';
const isProductGuide = process.env.PRODUCTGUIDE !== undefined;

export const ClientRoutes = isProductGuide ? [] : [...GeneralRoutes, MyAccountRoutes];
